import { oc } from "@orpc/contract";
import { z } from "zod";

export const ForecastApprovalKeySchema = z.object({
  warehouseId: z.string().uuid(),
  productV3Key: z.string().min(1),
});

export const ForecastApprovalStatusSchema = ForecastApprovalKeySchema.extend({
  approved: z.boolean(),
  decisionId: z.string().uuid().nullable(),
  reason: z.string().nullable(),
  decidedByUserId: z.string().uuid().nullable(),
  decidedByUserName: z.string().nullable(),
  decidedAt: z.string().nullable(),
});
export type ForecastApprovalStatus = z.infer<
  typeof ForecastApprovalStatusSchema
>;

export const GetForecastApprovalInputSchema = ForecastApprovalKeySchema;
export const GetForecastApprovalResponseSchema = z.object({
  status: ForecastApprovalStatusSchema,
});

export const SetForecastApprovalInputSchema = ForecastApprovalKeySchema.extend({
  approved: z.boolean(),
  reason: z.string().trim().min(1).max(1000),
});
export const SetForecastApprovalResponseSchema = z.object({
  status: ForecastApprovalStatusSchema,
  changed: z.boolean(),
});

export const forecastApprovalsContracts = {
  get: oc
    .input(GetForecastApprovalInputSchema)
    .output(GetForecastApprovalResponseSchema)
    .route({
      method: "GET",
      summary: "Get forecast approval status for a SKU",
      description:
        "Returns whether a SKU's forecast at a warehouse is approved (approved by default), with the latest decision's reason, who made it and when.",
    }),
  set: oc
    .input(SetForecastApprovalInputSchema)
    .output(SetForecastApprovalResponseSchema)
    .route({
      method: "POST",
      summary: "Approve or unapprove a SKU forecast",
      description:
        "Revokes or restores approval of a SKU's forecast at a warehouse, recording the reason and decider; reports whether the state changed.",
    }),
} as const;
